export const ConsumerAddressViewErrorStyles = {
  errorMessage: 'my-4',
}
